import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { DischargePlanningFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: DischargePlanningFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  let isFadingServicesLabel = "";
  if (formValues.isFadingServices === "YES") isFadingServicesLabel = "Yes";
  else if (formValues.isFadingServices === "NO") isFadingServicesLabel = "No";

  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Is the client currently fading services with AnswersNow?"
        value={isFadingServicesLabel}
      />
      <LabeledText
        label="Fading plan"
        value={formValues.isFadingServices === "YES" ? formValues.fadingPlan : ""}
      />
    </Grid>
  );
};

export default ViewFields;
